import { projectsProjectDetailHostCapability, projectsProjectDetailHostSlots, } from '@crest/module-projects/contracts/detail-host';
import { defineProjectsProjectDetailLauncher } from '@crest/module-projects/contracts/detail-launcher';
import { insuranceClaimsModuleManifest } from '../insurance-claims.module.js';
import { insuranceClaimsSettingRegistrations } from '../settings/insurance-claims-setting-definitions.js';
export const insuranceClaimsWebModuleContribution = {
    moduleId: 'insurance-claims',
    manifest: insuranceClaimsModuleManifest,
    settingRegistrations: insuranceClaimsSettingRegistrations,
    settingEditors: [],
    hostContracts: [],
    hostContributions: [{
            id: 'insurance-claims.web.projects.summary',
            moduleId: 'insurance-claims',
            slot: projectsProjectDetailHostSlots.sidebar,
            contractVersion: projectsProjectDetailHostCapability,
            requiredPermission: 'insurance-claims.claims.read',
            settingCondition: {
                key: 'insurance-claims.claims.display',
                property: 'projectPanelEnabled',
                equals: true,
            },
            priority: 55,
            errorBehavior: 'inline',
            emptyBehavior: 'inline',
            launcher: defineProjectsProjectDetailLauncher({
                fallbackLabel: 'Insurance',
                fallbackDescription: 'Open claim, scope, notice, and readiness details.',
                defaultSize: 'large',
                supportedSizes: ['standard', 'wide', 'large'],
            }),
            load: () => import('./insurance-claims-project-summary.panel.js'),
        }, {
            id: 'insurance-claims.web.projects.workflow',
            moduleId: 'insurance-claims',
            slot: projectsProjectDetailHostSlots.tabs,
            contractVersion: projectsProjectDetailHostCapability,
            requiredPermission: 'insurance-claims.scopes.read',
            settingCondition: {
                key: 'insurance-claims.workflow.display',
                property: 'projectWorkflowPanelEnabled',
                equals: true,
            },
            priority: 54,
            errorBehavior: 'inline',
            emptyBehavior: 'inline',
            load: () => import('./insurance-claims-project-workflow.panel.js'),
        }, {
            id: 'insurance-claims.web.projects.notice-sla',
            moduleId: 'insurance-claims',
            slot: projectsProjectDetailHostSlots.tabs,
            contractVersion: projectsProjectDetailHostCapability,
            requiredPermission: 'insurance-claims.aob-notices.read',
            settingCondition: {
                key: 'insurance-claims.notice-sla.display',
                property: 'projectNoticeSlaPanelEnabled',
                equals: true,
            },
            priority: 53,
            errorBehavior: 'inline',
            emptyBehavior: 'inline',
            load: () => import('./insurance-claims-project-notice-sla.panel.js'),
        }],
    routes: [{
            id: 'insurance-claims.web.workspace',
            moduleId: 'insurance-claims',
            path: '/insurance-claims',
            requiredPermission: 'insurance-claims.claims.read',
            navigation: {
                id: 'insurance-claims.navigation.workspace',
                fallbackLabel: 'Insurance claims',
                labelConfigurationKey: 'insurance-claims.copy.workspace',
                labelValueProperty: 'navigationLabel',
                priority: 75,
            },
            load: () => import('./insurance-claims-workspace.page.js'),
        }],
};
export default insuranceClaimsWebModuleContribution;
//# sourceMappingURL=insurance-claims-web.module-contribution.js.map